<mat-radio-group [(ngModel)]="selectedValue" class="radio-flex" [ngClass]="componentName === 'amicalOffer'? 'amicalOfferGap' : ''">
  <label
    for="{{ item.value }}"
    class="radio-card-wrapper"
    *ngFor="let item of data"
    [ngClass]="
    { 
      'is-checked': item.value === selectedValue, 
      'disabled-card': item.disabled 
    }"
    (click)="item.disabled ? null : onCardClick(item.value)"
  >
    <div class="first-row">
      <div [ngClass]="
        { 
          'first-row-icon': item.value !== selectedValue, 
          'first-row-icon-active': item.value === selectedValue 
        }">
        <mat-icon 
          svgIcon="{{item.value === selectedValue? item.ActiveIcon : item.disabledIcon }}"
        ></mat-icon>
      </div>
      <div class="action-wrapper">
        <img (click)="onplusClick($event,item.value)" class="plus-btn" *ngIf="componentName === 'amicalOffer'" src="../../../../assets/icons/plus-bleu.svg" alt="">
        <label class="container">
          <input
            (click)="$event.stopPropagation()"
            type="radio"
            [value]="item.value"item.disabled
            [disabled]="item.disabled" 
            [checked]="item.value === selectedValue"
            name="radio">
          <span class="checkmark"></span>
        </label>
      </div>
      
    </div>
    <div class="second-row">
      <span>{{ item.title }}</span>
      <p>{{ item.description }}</p>
    </div>
  </label>
</mat-radio-group>
